const _import = require('@/utils/import/_import_' + process.env.NODE_ENV)
import PropertiesRoutes from './components/Properties/routes'
import HookahMakersRoutes from './components/Hookah/routes'
import LogsRoutes from '@/modules/logs/routes'

const routes = [
  {
    path: '/settings',
    name: 'Settings',
    component: _import('settings/components/Wrapper'),
    meta: {
      showInMenu: true,
      title: 'Настройки',
      menuKey: 'Settings',
      roles: ['ROLE_ADMIN']
    },
    redirect: '/settings',
    children: [
      ...PropertiesRoutes,
      ...LogsRoutes,
      ...HookahMakersRoutes,
      {
        path: '',
        name: 'MainSettings',
        component: _import('settings/components/MainSettings'),
        meta: {
          showInMenu: true,
          title: 'Настройки заведения',
          menuKey: 'Settings',
          roles: ['ROLE_ADMIN', 'ROLE_WAITER']
        }
      },
      {
        path: 'accesspayment',
        name: 'AccessPayment',
        component: _import('settings/components/AccessPayment'),
        meta: {
          title: 'Оплата доступа',
          roles: ['ROLE_ADMIN', 'ROLE_WAITER']
        }
      },
      {
        path: 'tables',
        name: 'Table',
        component: _import('settings/components/Tables/list'),
        meta: {
          title: 'Столы',
          menuKey: 'Settings',
          roles: ['ROLE_ADMIN', 'ROLE_WAITER']
        }
      },
      {
        path: 'tables/create',
        name: 'Table.create',
        component: _import('settings/components/Tables/create'),
        meta: {
          title: 'Добавить стол',
          menuKey: 'Settings',
          roles: ['ROLE_ADMIN', 'ROLE_WAITER']
        }
      },
      {
        path: 'tables/:id',
        name: 'Table.info',
        component: _import('settings/components/Tables/info'),
        meta: {
          title: 'Cтолы',
          roles: ['ROLE_ADMIN', 'ROLE_WAITER']
        }
      },
      {
        path: 'tables/:id/edit',
        name: 'Table.edit',
        component: _import('settings/components/Tables/edit'),
        meta: {
          title: 'Редактирование стола',
          roles: ['ROLE_ADMIN', 'ROLE_WAITER']
        }
      },
      {
        path: 'discounts',
        name: 'discounts',
        component: _import('settings/components/Discounts'),
        meta: {
          title: 'Скидки',
        }
      },
      {
        path: 'discounts/edit',
        name: 'DiscountsEdit',
        component: _import('settings/components/DiscountsEdit'),
        meta: {
          title: 'Добавить скидки',
        }
      },

      {
        path: 'users',
        name: 'users',
        component: _import('settings/components/Users'),
        meta: {
          title: 'Пользователи',
        }
      },

      {
        path: 'users/create',
        name: 'createuser',
        component: _import('settings/components/CreateUser'),
        meta: {
          title: 'Добавить пользователя',
        }
      },

      {
        path: 'users/groups',
        name: 'usersgroup',
        component: _import('settings/components/UserGroup'),
        meta: {
          title: 'Группы пользователей',
        }
      },

      {
        path: 'users/groups/edit',
        name: 'UsersGroupEdit',
        component: _import('settings/components/UserGroupEdit'),
        meta: {
          title: 'Новая группа',
        }
      },

      {
        path: 'services',
        name: 'services',
        component: _import('settings/components/Services'),
        meta: {
          title: 'Услуги',
        }
      },

      {
        path: 'services/edit',
        name: 'ServicesEdit',
        component: _import('settings/components/ServicesEdit'),
        meta: {
          title: 'Новая услуга',
        }
      },

      {
        path: 'service_categories',
        name: 'service_categories',
        component: _import('settings/components/ServiceCategory'),
        meta: {
          title: 'Категории услуг',
        }
      },
      {
        path: 'service_categories/edit',
        name: 'Service_CategoriesEdit',
        component: _import('settings/components/ServiceCategoryEdit'),
        meta: {
          title: '',
        }
      },
      {
        path: 'whats_new',
        name: 'WhatsNew',
        component: _import('settings/components/WhatsNew'),
        meta: {
          title: 'Обновления',
        }
      },

    ]
  }
]

routes.forEach(route => {
  route.children.forEach(child => {
    child.meta.menuKey = 'Settings'
  })
})

export default routes



// WEBPACK FOOTER //
// ./src/modules/settings/routes.js